import PropTypes from "prop-types"

const PartnerShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  fundId: PropTypes.string,
  sponsorId: PropTypes.string,
  projectId: PropTypes.string.isRequired,
  fundRaisedAmount: PropTypes.number,
  targetAmount: PropTypes.number.isRequired,
  nonAccreditedInvestorsMax: PropTypes.number,
})

export default PartnerShape
